import { render, staticRenderFns } from "./LocationStatsGrid.vue?vue&type=template&id=227ef9ac"
import script from "./LocationStatsGrid.vue?vue&type=script&lang=js"
export * from "./LocationStatsGrid.vue?vue&type=script&lang=js"
import style0 from "./LocationStatsGrid.vue?vue&type=style&index=0&id=227ef9ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports